import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import emailjs from "emailjs-com";

const Contact = () => {
  const [formData, setFormData] = useState({
    sender_full_name: "",
    sender_position: "",
    sender_organization: "",
    sender_email_or_phone_number: "",
    sender_message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Input validation
    if (!formData.sender_full_name || !formData.sender_organization || !formData.sender_message || !formData.sender_email_or_phone_number || !formData.sender_position) {
      setStatus("Please fill out all fields.");
      return;
    }

    const templateParams = {
      sender_full_name: formData.sender_full_name,
      sender_position: formData.sender_position,
      sender_organization: formData.sender_organization,
      sender_email_or_phone_number: formData.sender_email_or_phone_number,
      sender_message: formData.sender_message,
    };

    emailjs
      .send(
        "service_amj4u1g", // Replace with your Service ID
        "template_w5ciaek", // Replace with your Template ID
        templateParams,
        "kdgC2rjRway68vssq" // Replace with your User ID (Public Key)
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          setStatus("Your email has been sent to us successfully!");
          setFormData({ sender_full_name: "", sender_organization: "", sender_message: "", sender_email_or_phone_number:"", sender_position:"" });
        },
        (error) => {
          console.error("FAILED...", error);
          setStatus(`Failed to send email: ${error.text || error.message}`);
        }
      );
  };

  return (
    <section className="contact overflow-hidden" id="contact">
      <Container>
        <Row className="justify-content-center">
          <Col lg={12}>
            <div className="sec-hd mb-4">
              <span className="heading"></span>
              <h2 className="sec-title">Contact Us</h2>
              <span className="heading"></span>
            </div>
          </Col>
        </Row>
        <Row className="align-items-center justify-content-center">
          <Col lg={8}>
            <form onSubmit={handleSubmit}>
              <Row>
                <Col lg={12}>
                  <div className="form-group">
                    <input
                      name="sender_full_name"
                      type="text"
                      className="form-control"
                      placeholder="Enter Full Name"
                      value={formData.sender_full_name}
                      onChange={handleChange}
                    />
                  </div>
                </Col>
                <br />
                <br></br>
                <br />
                <Col lg={12}>
                  <div className="form-group">
                    <input
                      name="sender_position"
                      type="text"
                      className="form-control"
                      placeholder="Enter Position"
                      value={formData.sender_position}
                      onChange={handleChange}
                    />
                  </div>
                  </Col>
                <br />
                <br></br>
                <br />
                <Col lg={12}>
                  <div className="form-group">
                    <input
                      name="sender_organization"
                      type="text"
                      className="form-control"
                      placeholder="Enter Organization / Company Name"
                      value={formData.sender_organization}
                      onChange={handleChange}
                    />
                  </div>
                </Col>
                <br></br>
                <br></br>
                <br></br>

                <Col lg={12}>
                  <div className="form-group">
                    <input
                      name="sender_email_or_phone_number"
                      type="text"
                      className="form-control"
                      placeholder="Enter Email / Phone Number"
                      value={formData.sender_email_or_phone_number}
                      onChange={handleChange}
                    />
                  </div>
                </Col>
              </Row>
              <br />
              <Row>
                <Col lg={12}>
                  <div className="form-group">
                    <textarea
                      name="sender_message"
                      rows="6"
                      className="form-control"
                      placeholder="Enter a Message"
                      value={formData.sender_message}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                </Col>
              </Row>
              <br />
              <Row className="justify-content-center">
                <Col lg={6}>
                  <button type="submit" className="btn btn-primary w-100">
                    Submit 
                  </button>
                </Col>
              </Row>
            </form>
            {status && (
              <p
                className={`text-center mt-3 ${
                  status.includes("Failed") ? "text-danger" : "text-success"
                }`}
              >
                {status}
              </p>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Contact;
